export enum SearchParams {
  SEARCH = 'search',
  SORT_BY = 'sortBy',
}

export interface FilterParams {
  search?: string;
  sortBy?: string | null;
}
